import {Nullish} from 'shared/web';

import {SourcingType} from '../../../hooks/useSourcingType';
import {VehicleCategoryFilter} from '../types/VehicleCategoryFilter';

/**
 * Van body length / height filters apply only to vans on classifieds: `all_auctions` ignores the
 * length and height classes, and a passenger-car search has no use for them.
 */
export const areVanDimensionFiltersVisible = (
  vehicleCategory: VehicleCategoryFilter | Nullish,
  sourcingType: SourcingType,
  isVanFiltersEnabled: boolean
): boolean =>
  isVanFiltersEnabled &&
  sourcingType === SourcingType.CLASSIFIEDS &&
  vehicleCategory !== VehicleCategoryFilter.CAR;
